import { render } from "./StayAddOns.vue?vue&type=template&id=52d2196c"
import script from "./StayAddOns.vue?vue&type=script&lang=js"
export * from "./StayAddOns.vue?vue&type=script&lang=js"

import "@/modules/stay/css/add-ons.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__